import { apiRequest } from "./client";
import {
  getDesktopDeepLinkScheme,
  getDesktopLinkOrigin,
} from "@/lib/desktop-deep-link";

export async function authorizeNativePasswordReset(data: {
  uid: string;
  token: string;
  context: string;
}) {
  const controller = new AbortController();
  const timer = setTimeout(() => controller.abort(), 20_000);
  try {
    const result = await apiRequest<{ url: string }>(
      "/api/v1/auth/desktop/password/reset/authorize/",
      {
        method: "POST",
        body: data,
        signal: controller.signal,
        silent: true,
      },
    );
    const url = new URL(result.url);
    const entries = [...url.searchParams.entries()];
    const origin = getDesktopLinkOrigin();
    const origins = url.searchParams.getAll("origin");
    if (
      url.protocol !== `${getDesktopDeepLinkScheme()}:` ||
      url.hostname !== "reset-password" ||
      url.username ||
      url.password ||
      url.port ||
      url.pathname ||
      url.hash ||
      entries.length !== (origin === null ? 2 : 3) ||
      (origin === null
        ? origins.length !== 0
        : origins.length !== 1 || origins[0] !== origin) ||
      !["code", "state"].every(
        (key) =>
          url.searchParams.getAll(key).length === 1 &&
          new RegExp(`^[A-Za-z0-9_-]{${key === "code" ? 43 : 16},128}$`).test(
            url.searchParams.get(key) ?? "",
          ),
      )
    ) {
      throw new Error("Invalid native return.");
    }
    return url.toString();
  } finally {
    clearTimeout(timer);
  }
}
